interface SendbirdDefaultAdminMessage {
  message: string;
}

export function SendbirdDefaultAdminMessage({ message }) {
  return (
    <div className="sendbird-admin-message">
      <span className="sendbird-admin-message__text sendbird-label sendbird-label--caption-2 sendbird-label--color-onbackground-2">
        {message}
      </span>
    </div>
  );
}
